// ---------------------------------------------------------------------------
// IDs
// ---------------------------------------------------------------------------
export const C2S = {
    // 1–9 session & clock
    Ping: 1, //            F  PingMsg
    Presence: 2, //        F  PresenceMsg
    // 10–19 movement
    Move: 10, //           F  MoveIntent
    Stop: 11, //           F  StopIntent
    // 20–29 objects
    Interact: 20, //       R  InteractRequest -> InteractResult
    InteractCancel: 21, // F  InteractCancelMsg
    // 30–39 local social
    Say: 30, //            F  SayMsg
    Emote: 31, //          F  EmoteMsg (emote or chip id)
    // 40–49 travel
    Travel: 40, //         R  TravelRequest -> TravelResult
    // 50–69 reserved: phone (sprint sends over REST, 92 A10)
    // 70–89 voice (doc 50)
    VoiceJoin: 70, //      R  {} -> VoiceGrant
    VoiceTalk: 71, //      F  VoiceTalkMsg
    // 90–99 reserved: safety
    // 100–109 home & build
    BuildOps: 101, //      R  BuildOpsRequest -> BuildOpsResult
    Knock: 105, //         R  KnockRequest -> OkResult
    KnockAnswer: 106, //   F  KnockAnswerMsg
    // 110–127 hustle (akara, doc 12)
    StallOpen: 110, //     R  StallOpenRequest -> StallOpenResult
    FryScoop: 111, //      F  FryScoopMsg
    FryFlip: 112, //       F  FryTimingMsg
    FryRemove: 113, //     F  FryTimingMsg
    Serve: 114, //         F  ServeMsg
    CardChoose: 115, //    R  CardChooseRequest -> OkResult
    StallClose: 116, //    F  {}
    // 200–209 dev only, rejected when NODE_ENV=production
    DevPower: 201, //      F  DevPowerMsg
};
export const S2C = {
    // 1–9 session
    Welcome: 1, //         P  WelcomeMsg (after every join and every successful reconnect)
    Pong: 2, //            P  PongMsg
    Notice: 3, //          P  NoticeMsg
    Error: 4, //           P  ErrorMsg
    OwnerState: 5, //      P  OwnerStateMsg (owner only, 92 A8)
    // 10–19 movement
    MoveRejected: 10, //   P  MoveRejectedMsg (owner only)
    // 30–39 local social
    Said: 30, //           P  SaidMsg
    Emoted: 31, //         P  EmotedMsg
    // 50–69 phone live delivery (doc 51)
    PhoneChatNew: 50, //   P  PhoneChatNewMsg
    BankNotice: 52, //     P  BankNoticeMsg
    // 100–109 home
    KnockIncoming: 105, // P  KnockIncomingMsg (home owner only)
    // 110–127 economy / hustle
    WalletChanged: 110, // P  WalletChangedMsg (owner only, after a ledger commit)
    FryResult: 112, //     P  FryResultMsg
    Customers: 113, //     P  CustomersMsg
    CardOffer: 114, //     P  CardOfferMsg
    SaleDone: 115, //      P  SaleDoneMsg
};
/** Reverse lookup for logs: C2S id -> name. */
export const C2S_NAME = Object.fromEntries(Object.entries(C2S).map(([k, v]) => [v, k]));
/** Reverse lookup for logs: S2C id -> name. */
export const S2C_NAME = Object.fromEntries(Object.entries(S2C).map(([k, v]) => [v, k]));
/** C2S ids answered through `room.request()` (43 P4). */
export const C2S_REQUESTS = new Set([
    C2S.Interact,
    C2S.Travel,
    C2S.VoiceJoin,
    C2S.BuildOps,
    C2S.Knock,
    C2S.StallOpen,
    C2S.CardChoose,
]);
/** C2S ids the server drops when NODE_ENV=production. */
export const C2S_DEV_ONLY = new Set([C2S.DevPower]);
/**
 * Custom WebSocket close codes. Colyseus reserves 4000–4010 and 4217.
 * 4103 is `session_moved` in the sprint (LL-50: one live session per account).
 */
export const AppClose = {
    AuthExpired: 4100,
    ClientOutdated: 4101,
    Kicked: 4102,
    SessionMoved: 4103,
    Migrated: 4104,
    IdleTimeout: 4105,
    RateLimited: 4106,
    Banned: 4107,
};
/** `ErrorMsg.code` values (43 §3.10). */
export const ErrorCode = {
    BadRequest: 'bad_request',
    RateLimited: 'rate_limited',
    NotAllowed: 'not_allowed',
    Internal: 'internal',
    ClientOutdated: 'client_outdated',
    BadTicket: 'bad_ticket',
    InstanceFull: 'instance_full',
    CharacterInUse: 'character_in_use',
    Banned: 'banned',
    AreaUnavailable: 'area_unavailable',
    NotReachable: 'not_reachable',
    ObjectBusy: 'object_busy',
    ObjectInvalid: 'object_invalid',
    TooFar: 'too_far',
};
/** `MoveRejectedMsg.reason` values (43 §3.4). */
export const MoveRejectReason = {
    Blocked: 'blocked',
    Unreachable: 'unreachable',
    TooFar: 'too_far',
    Busy: 'busy',
    RateLimited: 'rate_limited',
};
/** Emote ids (43 §3.6): 1 wave, 2 hail, 3 "eh-hen"; more in doc 10. */
export const Emote = { Wave: 1, Hail: 2, EhHen: 3 };
